<template>
  <div class="before">
    <div class="content">
        <SelectRadio
          v-for="(item, index) in radioDatalist"
          :radioData="item"
          :key="index"
          :Finished=" index == 0 ? radioFinished1 : radioFinished2"
        >
        </SelectRadio>
       <div v-show="['203','204'].includes(tradingChannel)" class="moneyloss">
        <div class="title">请填写您的损失金额（元）</div>
        <z-field
          :use-number-keyboard="true"
          clearable
          v-model="moneyLoss"
          darkBg
          @focus="showNumberKeyboard = true"
          @blur="showNumberKeyboard = false"
        ></z-field>
      </div>
      <SelectRadio
        class="selectradiolast"
        v-show="Object.keys(questions).length > 0"
        :key="userRole + tradingChannel"
        :radioData="questions"
        :Finished="questionFinished"
      >
      </SelectRadio>
    </div>
    <z-number-keyboard
      close-on-click-overlay
      :show="showNumberKeyboard"
      @input="onInput"
      @delete="onDelete"
    >
    </z-number-keyboard>
    <z-button-group>
      <z-button :disabled="!canSubmit" type="primary" @click="next">下一步</z-button>
    </z-button-group>
  </div>
</template>

<script>
import SelectRadio from '../../components/SelectRadio'
import { Button, ButtonGroup, Field, NumberKeyboard } from '@zz-common/zz-ui'
import { newReportGetQuestion } from '@api/resourceApi'
export default {
  name: 'BeforeFraud',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    zField: Field,
    SelectRadio,
    'z-number-keyboard': NumberKeyboard
  },
  inject: ['sharedData', 'mergeSubmitData', 'submitData'],
  data() {
    return {
      showNumberKeyboard: false,
      moneyLoss: '',
      userRole: '', //用户角色
      tradingChannel: '', //交易渠道
      chooseType: '', //勾选证据类型 1商品2私信3订单
      chooseEvidence: '', //1 商品是商品id 2 私信是私信内容 3 订单是订单id  多个用逗号分割
      questionId: '', //选择的问题id
      questionDesc: '', //选择的问题
      //缓存问题
      cacheQuestion: {},
      //选择问题
      questions: {}
    }
  },
  computed: {
    canSubmit() {
      if (['203', '204'].includes(this.tradingChannel)) {
        return this.userRole && this.tradingChannel && this.moneyLoss && this.questionId
      } else {
        return this.userRole && this.tradingChannel && this.questionId
      }
    },
    radioDatalist() {
      return this.sharedData.firstReason.ext || []
    },
    roleandchannel() {
      return {
        userRole: this.userRole,
        tradingChannel: this.tradingChannel
      }
    }
  },
  watch: {
    roleandchannel(val) {
      if (!val.userRole || !val.tradingChannel) {
        return
      }
      this.questionId = ''
      const searchtype = this.sharedData.firstReason.id + '-' + val.userRole + '-' + val.tradingChannel
      if (!this.cacheQuestion[searchtype]) {
        console.log('看看提交参数', searchtype, this.cacheQuestion)
        newReportGetQuestion({ type: searchtype }).then(res => {
          this.questions = res
          this.cacheQuestion[searchtype] = res
        })
      } else {
        this.questions = this.cacheQuestion[searchtype]
      }
    }
  },
  methods: {
    next() {
      this.mergeSubmitData({
        userRole: this.userRole,
        tradingChannel: this.tradingChannel,
        questionId: this.questionId,
        questionDesc: this.questionDesc,
        chooseType: this.tradingChannel == '203' ? this.chooseType : '',
        chooseEvidence: this.tradingChannel == '203' ? this.chooseEvidence : '',
        moneyLoss: ['203', '204'].includes(this.tradingChannel) ? this.moneyLoss : ''
      })
      if (this.questionId == '2120301') {
        this.$router.push('/newreport/fraud/phonerelated')
      } else {
        this.$router.push('/newreport/fraud/afterfraud')
      }
    },
    radioFinished1(data) {
      this.userRole = data.evidence
    },
    radioFinished2(data) {
      this.tradingChannel = data.evidence
      if (data.evidence == '203') {
        this.chooseType = '3'
        this.chooseEvidence = data.selectOrder.map(t => t.orderId).join(',')
      }
    },
    questionFinished(data) {
      this.questionId = data.evidence
      this.questionDesc = data.desc
    },
    onInput(value) {
      this.moneyLoss += value;
    },
    onDelete() {
      this.moneyLoss = this.moneyLoss.slice(0, -1);
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>